import Vue from 'vue'
import ElementUI from 'element-ui';
import "element-ui/lib/theme-chalk/base.css";
import "./assets/scss/reset.scss";
import "./assets/theme/index.css";
import "./assets/scss/base.scss";
import './assets/scss/userContent.scss'
import "./assets/iconfont/iconfont.css";
import "./assets/iconfont/iconfont.js";
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

// 检测用户操作时间长久
import Automatic from '@/util/automatic'
Vue.use(Automatic)

import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
Vue.component(CollapseTransition.name, CollapseTransition)

// i18n 国际化（vue-i18n，支持中英文切换）
import i18n from './locale'
import App from './App.vue'
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.use(VueAxios, axios)

import base from "@/util/base";
Vue.use(base);

// 全局混入：代表队提交后（status === 2）锁定编辑，各页面通过 isTeamSubmitted / checkTeamLock 使用
import teamLock from "@/mixins/teamLock";
Vue.mixin(teamLock);

// 全局混入：中英文字段取值，英文模式下英文字段为空时回退读取中文字段，各页面通过 localeValue 使用
import i18nField from "@/mixins/i18nField";
Vue.mixin(i18nField);

import Vue2OrgTree from 'vue2-org-tree';
Vue.use(Vue2OrgTree)

Object.assign(Vue.prototype, {
  define: require('./util/define'),
})

// 判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {// 判断是否需要登录权限
    if (window.localStorage.getItem('token')) {// 判断是否登录
      next()
    } else {// 没登录则跳转到登录界面
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    // if (to.matched.length === 0) {
    //   next('/empty-pages') // 判断此跳转路由的来源路由是否存在，存在的情况跳转到来源路由，否则跳转到404页面
    // }
    next()
  }
})
router.afterEach((to, from) => {
  //将滚动条恢复到最顶端
  window.scrollTo(0, 0);
})

new Vue({
  store,
  router,
  i18n,    // 注入 i18n，使所有组件可通过 $t() 访问
  render: h => h(App),
}).$mount('#app')
